import type { ReactNode } from "react";
import { MemoComposer } from "./MemoComposer";
import { MemoThread } from "./MemoThread";
import type { MemoController } from "./useMemoController";
import styles from "./MemoPanel.module.css";

// 작성창(상단)과 메모 목록(하단)이다. 팝업·모달이 공유하는 메모 본문이다. compact 는 팝업처럼
// 좁은 컨테이너에서 간격을 줄인다.
export function MemoPanel({
  controller,
  compact = false,
}: {
  controller: MemoController;
  compact?: boolean;
}): ReactNode {
  return (
    <div className={styles.panel} data-compact={compact ? "true" : undefined}>
      <MemoComposer controller={controller} />
      <div className={styles.divider} />
      <MemoThread controller={controller} compact={compact} />
    </div>
  );
}
